<template>
  <v-app>
    <v-app-bar
      app
      color="orange"
      dark
      style="xbackground: linear-gradient(0deg, white 0%, rgb(255, 152, 0) 10%)"
    >
      <div class="d-flex align-center">
        <v-icon x-large
            @click="shuffle()">
            mdi-egg-fried
        </v-icon>

        <div class="text-h5 ml-1 font-weight-bold">DAILY EGG</div>
      </div>

      <v-spacer></v-spacer>
      WIR HABEN <span class="mx-1" style="color:rgba(255,255,255,.5)">{{ eggs.length }}</span> EIER
      <v-spacer></v-spacer>

      <!--<v-btn
        @click="shuffle"
        target="_blank"
        icon
        class="mr-1"
      >
        <v-icon>mdi-shuffle</v-icon>
      </v-btn>-->

    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
            icon
            v-bind="attrs"
            v-on="on"
            @click="sorting(sorted ? null : 'date')"
            >
            <v-icon v-if="!sorted">mdi-calendar</v-icon>
            <v-icon v-else>mdi-shuffle</v-icon>
        </v-btn>
      </template>
      <span v-if="!sorted">Sort by Date</span>
      <span v-else>Shuffle Eggs</span>
    </v-tooltip>

        <v-badge
            offset-y="20"
            offset-x="20"
          color="orange"
          :content="sortedIngredients.length"
        >

            <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    >
                    <v-icon>mdi-filter</v-icon>
                    </v-btn>
                </template>
                
                <v-list :style="{maxHeight: `${menuHeight}px`}" width="500" class="overflow-y-auto">
                    <v-list-item v-if="sortBy">
                    <v-btn
                            elevation=0
                            plain
                            width="100%"
                            style="text-align:left;"
                            @click="filter(null)">
                            <v-list-item-title>All</v-list-item-title>
                        </v-btn>
                    </v-list-item>
                    <v-list-item
                        v-for="(item, index) in sortedIngredients"
                        :key="index"
                    >
                        <v-btn
                            elevation=0
                            plain
                            width="100%"
                            style="text-align:left;"
                            @click="filter(item)">
                            <v-list-item-title>
                                <v-row>
                                    <v-col>{{ item }}</v-col>
                                    <v-col cols="2">({{ ingredients[item] }})</v-col>
                                
                                </v-row></v-list-item-title>
                        </v-btn>
                    
                    </v-list-item>
                </v-list>
            </v-menu>

        </v-badge>

      <v-dialog
        v-model="dialog"
        width="500"
        @click:outside="closeDialog()"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    target="_blank"
                    icon
                    v-bind="attrs"
                    v-on="on"
                    class="mr-0"
                >
                    <v-icon>mdi-gift-outline</v-icon>
                </v-btn>
            </template>

            <v-card
                max-width="500"
            >

                <v-img
                    height="250"
                    style="border: 3px solid #fff;"
                    :src="randomImage"
                ></v-img>

                <v-card-title>
                <v-icon class="mr-1" color="rgba(0,0,0,0.8)">
                    mdi-egg-fried
                </v-icon>
                    Random Egg
                </v-card-title>

                <v-card-text>
                    <v-row
                        align="center"
                        class="mx-0"
                    >
                        <v-rating
                            :value="parseFloat(rating)"
                            color="amber"
                            dense
                            half-increments
                            readonly
                            size="14"
                        ></v-rating>

                        <div class="grey--text ms-4">
                            {{ rating }}
                        </div>
                    </v-row>

                    <div class="my-4 text-subtitle-1">
                    
                    </div>

                    <div>
                        <span class="mr-2" v-for="(item, index) in random()" :key="index">
                            <v-chip
                                class="ma-1"
                                :color="sortBy === item ? 'success' : 'orange'"
                                label
                                outlined
                                @click="filterClose(item)"
                                >
                                {{ item }}
                            </v-chip>
                        </span>
                    </div>
                </v-card-text>

                <v-divider class="mx-4"></v-divider>

                <v-card-title style="justify-content:end">
                    <v-icon class="mr-2" color="error">mdi-heart</v-icon>
                    yUM yUM
                    <v-icon class="ml-2" color="error">mdi-heart</v-icon>
                </v-card-title>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="bdialog"
            max-width="1200"
            @click:outside="bdialog = false"
            >

            <v-card
                class="rounded-xl"
            >
                <v-card-title id="btext" class="text-h1 pa-8">
                    <v-img class="mr-4" max-width="500" max-height="500" :src="`img/icons/favicon.svg`"></v-img>
                    Happy&nbsp;<span :style="isBday() ? {color: 'rgba(0,0,0,.7)', textDecorationLine: 'line-through', textDecorationThickness: '3px'} : {}">&nbsp;Egg&nbsp;</span>&nbsp;<span v-if="isBday()" style="color:rgba(255, 152, 0,.9);">Birth</span><wbr />day !!!
                </v-card-title>
            </v-card>
        </v-dialog>
    </v-app-bar>

    <v-main>
      <router-view/>
    </v-main>


    <div style="color: rgba(255, 152, 0,.8);position:fixed;bottom:.5em;right:1em;">
        2022 &copy; MyBoom Studios
    </div>
  </v-app>
</template>

<script>

import { mapState, mapActions } from 'vuex'

export default {
    name: 'App',

    data: () => ({
        dialog: false,
        rating: 4.5,
        menuHeight: 500,
        bdialog: true,
        sorted: false,
    }),

    computed: {
        ...mapState({
            eggs: 'items',
            sortBy: 'sortBy',
        }),

        ingredients: function() {
            const ingred = []
            const ingredStats = {}
            for (let item of this.eggs) {
                const comps = item.desc.split(', ');
                for (let comp of comps) {
                    if (!ingred.includes(comp)) {
                        ingred.push(comp)
                        ingredStats[comp] = 0
                    }

                    ingredStats[comp] += 1
                }
            }

            return ingredStats
            /*return ingred.sort(function (a, b) {
                return a.toUpperCase() > b.toUpperCase()
            })*/
        },

        sortedIngredients: function() {
            return Object.keys(this.ingredients).sort(function (a, b) {
                                    return a.toUpperCase() > b.toUpperCase()
                                })
        },

        randomImage: function() {
            const imgIdx = Math.floor(Math.random() * (this.eggs.length-1))

            return require(`@/assets/eggs/${this.eggs[imgIdx].name}`)
        },
    },

    created() {
        this.shuffle()
        this.menuHeight = window.innerHeight-100
    },

    methods: {
        ...mapActions({
            shuffle: 'shuffle',
            filter: 'filter',
            sort: 'sort',
        }),

        sorting(type) {
            this.sort(type)
            this.sorted = type === 'date'
        },

        isBday: function() {
            return (Date.now() >= 1652220000000) && (Date.now() < 1652652000000)
        },

        random() {
            const icount = Math.floor(Math.random() * 6)
            const inList = [...this.sortedIngredients]
            inList.sort(function() {
                return Math.random() - 0.5
            })

            let randomList
            const redList = inList.slice(0, icount+2)
            if (this.sortBy) {
                const sIdx = redList.indexOf(this.sortBy)
                if (sIdx < 0) {
                    randomList = [this.sortBy, ...redList]
                } else {
                    randomList = redList
                }
            } else {
                randomList = redList
            }
/*            while (randomList.length <= icount+2) {
                const index = Math.floor(Math.random() * (this.ingredients.length-1))
                
                const i = this.ingredients[index]
                console.log(i)
                if (!randomList.includes(i)) {
                    randomList.push(i)
                }
            }
*/
            this.rating = (Math.random() * (5 - 3.5) + 3.5).toFixed(1)

            return randomList
        },

        closeDialog()  {
            this.dialog = false
            this.shuffle()
        },

        filterClose(item) {
            this.filter(item)
            this.dialog = false
        }
    }
};
</script>

<style scoped>
    @font-face {
        font-family: "PermanentMarker";
        src: local("PermanentMarker"),   url(./fonts/PermanentMarker-Regular.ttf) format("truetype");
    }

    #btext {
        font-family: "PermanentMarker", Helvetica, Arial !important;
    }
</style>